export const localidades = [
  "25 de Mayo",
  "Abramo",
  "Adolfo Van Praet",
  "Agustoni",
  "Algarrobo del Águila",
  "Alpachiri",
  "Alta Italia",
  "Anguil",
  "Arata",
  "Ataliva Roca",
  "Bernardo Larroudé",
  "Bernasconi",
  "Caleufú",
  "Carro Quemado",
  "Casa de Piedra",
  "Catriló",
  "Chacharramendi",
  "Colonia Barón",
  "Colonia Santa María",
  "Conhelo",
  "Coronel Hilario Lagos",
  "Cuchillo Co",
  "Doblas",
  "Dorila",
  "Eduardo Castex",
  "Embajador Martini",
  "General Acha",
  "General Campos",
  "General Pico",
  "General San Martín",
  "Gobernador Duval",
  "Guatraché",
  "Ingeniero Luiggi",
  "Intendente Alvear",
  "Jacinto Arauz",
  "La Adela",
  "La Humada",
  "La Maruja",
  "La Reforma",
  "Limay Mahuida",
  "Lonquimay",
  "Luan Toro",
  "Macachín",
  "Maisonnave",
  "Mauricio Mayer",
  "Miguel Cané",
  "Miguel Riglos",
  "Monte Nievas",
  "Parera",
  "Perú",
  "Pichi Huinca",
  "Puelén",
  "Puelches",
  "Pun Mahuida",
  "Quetrequén",
  "Rancul",
  "Realicó",
  "Relmo",
  "Rolón",
  "Rucanelo",
  "Sarah",
  "Speluzzi",
  "Santa Isabel",
  "Santa Rosa",
  "Telén",
  "Toay",
  "Tomas Manuel de Anchorena",
  "Trebolares",
  "Unanue",
  "Uriburu",
  "Vértiz",
  "Victorica",
  "Villa Mirasol",
  "Villa Turística Casa de Piedra",
  "Winifreda",
];
